import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { testimonialsData } from '../mock';

export const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonialsData.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonialsData.length) % testimonialsData.length);
  };

  useEffect(() => {
    const interval = setInterval(nextTestimonial, 7000);
    return () => clearInterval(interval);
  }, []);

  const currentTestimonial = testimonialsData[currentIndex];

  return (
    <section className="relative py-24 bg-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-3">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h60v1H0zM0 59h60v1H0z' fill='%23000000' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-sm tracking-[0.3em] uppercase text-gray-500 font-light">
              Client Testimonials
            </span>
            <div className="h-px w-16 bg-gray-900 mt-2 mx-auto" />
          </div>
          <h2 className="text-4xl lg:text-5xl font-light text-gray-900">
            Trusted by Architects
          </h2>
        </div>

        {/* Testimonial Card */}
        <div className="relative">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-12 md:p-16 shadow-xl border border-gray-100">
            {/* Quote Icon */}
            <div className="mb-8">
              <Quote className="w-12 h-12 text-gray-300" />
            </div>

            {/* Testimonial Text */}
            <p className="text-2xl md:text-3xl font-light text-gray-900 leading-relaxed mb-12 min-h-[120px]">
              "{currentTestimonial.text}"
            </p>

            {/* Author */}
            <div className="flex items-center justify-between">
              <div>
                <h4 className="text-xl font-medium text-gray-900 mb-1">
                  {currentTestimonial.name}
                </h4>
                <p className="text-gray-600 text-sm">
                  {currentTestimonial.role}
                </p>
              </div>

              {/* Navigation */}
              <div className="flex items-center gap-4">
                <button
                  onClick={prevTestimonial}
                  className="w-12 h-12 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-900 hover:border-gray-900 hover:text-white transition-all duration-300 group"
                  aria-label="Previous testimonial"
                >
                  <ChevronLeft className="w-5 h-5" />
                </button>
                <button
                  onClick={nextTestimonial}
                  className="w-12 h-12 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-900 hover:border-gray-900 hover:text-white transition-all duration-300 group"
                  aria-label="Next testimonial"
                >
                  <ChevronRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>

          {/* Indicators */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonialsData.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-1 rounded-full transition-all duration-500 ${
                  index === currentIndex ? 'w-12 bg-gray-900' : 'w-6 bg-gray-300'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};